import { RuleResult } from 'types/DeclarationP5'
import { removePrefix } from 'shared/ncts/common/classifier-util'
import { LocationOfGoods } from '../../common/types'

// Unknown qualifiers or unselected values are by default as NOT_ALLOWED
const C0394Validator = {
  validateUnLocodeRequirement: ({
    locationOfGoods,
  }: {
    locationOfGoods?: LocationOfGoods
  }): RuleResult => {
    if (!locationOfGoods) return 'OPTIONAL'
    const qualifier = removePrefix(locationOfGoods.qualifierOfIdentification, 'QUALIFIER_OF_IDENTIFICATION_')

    switch (qualifier) {
      case 'U': return 'REQUIRED'
      case 'Z':
      case 'X':
      case 'Y':
      case 'W':
      case 'V':
      case 'T':
        return 'NOT_ALLOWED'
      default:
        return 'NOT_ALLOWED'
    }
  },
  validateCustomsOfficeRequirement: ({
    locationOfGoods,
  }: {
    locationOfGoods?: LocationOfGoods
  }): RuleResult => {
    if (!locationOfGoods) return 'OPTIONAL'
    const qualifier = removePrefix(locationOfGoods.qualifierOfIdentification, 'QUALIFIER_OF_IDENTIFICATION_')

    switch (qualifier) {
      case 'V': return 'REQUIRED'
      case 'Z':
      case 'X':
      case 'Y':
      case 'W':
      case 'U':
      case 'T':
        return 'NOT_ALLOWED'
      default:
        return 'NOT_ALLOWED'
    }
  },
  validateEconomicOperatorRequirement: ({
    locationOfGoods,
  }: {
    locationOfGoods?: LocationOfGoods
  }): RuleResult => {
    if (!locationOfGoods) return 'OPTIONAL'
    const qualifier = removePrefix(locationOfGoods.qualifierOfIdentification, 'QUALIFIER_OF_IDENTIFICATION_')

    switch (qualifier) {
      case 'X': return 'REQUIRED'
      case 'Z':
      case 'Y':
      case 'W':
      case 'V':
      case 'U':
      case 'T':
        return 'NOT_ALLOWED'
      default:
        return 'NOT_ALLOWED'
    }
  },
  validateAuthorisationNumberRequirement: ({
    departureCustomsOffice,
    locationOfGoods,
  }: {
    departureCustomsOffice: string
    locationOfGoods?: LocationOfGoods
  }): RuleResult => {
    const country = departureCustomsOffice?.slice('DEPARTURE_OFFICE_'.length, 'DEPARTURE_OFFICE_'.length + 2)
    if (country === 'FI') return 'NOT_ALLOWED'
    if (!locationOfGoods) return 'NOT_ALLOWED'
    const qualifier = removePrefix(locationOfGoods.qualifierOfIdentification, 'QUALIFIER_OF_IDENTIFICATION_')

    switch (qualifier) {
      case 'Y': return 'REQUIRED'
      case 'Z':
      case 'X':
      case 'W':
      case 'V':
      case 'U':
      case 'T':
        return 'NOT_ALLOWED'
      default:
        return 'NOT_ALLOWED'
    }
  },
  validatePostCodeAddressRequirement: ({
    locationOfGoods,
  }: {
    locationOfGoods?: LocationOfGoods
  }): RuleResult => {
    if (!locationOfGoods) return 'OPTIONAL'
    const qualifier = removePrefix(locationOfGoods.qualifierOfIdentification, 'QUALIFIER_OF_IDENTIFICATION_')

    switch (qualifier) {
      case 'T': return 'REQUIRED'
      case 'Z':
      case 'X':
      case 'Y':
      case 'W':
      case 'V':
      case 'U':
        return 'NOT_ALLOWED'
      default:
        return 'NOT_ALLOWED'
    }
  },
  validateGnssRequirement: ({
    locationOfGoods,
  }: {
    locationOfGoods?: LocationOfGoods
  }): RuleResult => {
    if (!locationOfGoods) return 'OPTIONAL'
    const qualifier = removePrefix(locationOfGoods.qualifierOfIdentification, 'QUALIFIER_OF_IDENTIFICATION_')

    switch (qualifier) {
      case 'W': return 'REQUIRED'
      case 'Z':
      case 'X':
      case 'Y':
      case 'V':
      case 'U':
      case 'T':
        return 'NOT_ALLOWED'
      default:
        return 'NOT_ALLOWED'
    }
  },
  validateContactPersonRequirement: ({
    locationOfGoods,
  }: {
    locationOfGoods?: LocationOfGoods
  }): RuleResult => {
    if (!locationOfGoods) return 'OPTIONAL'
    const qualifier = removePrefix(locationOfGoods.qualifierOfIdentification, 'QUALIFIER_OF_IDENTIFICATION_')

    switch (qualifier) {
      case 'V': return 'NOT_ALLOWED'
      case 'Z':
      case 'X':
      case 'Y':
      case 'W':
      case 'U':
      case 'T':
        return 'OPTIONAL'
      default:
        return 'NOT_ALLOWED'
    }
  },
  validateAddressRequirement: ({
    locationOfGoods,
  }: {
    locationOfGoods?: LocationOfGoods
  }): RuleResult => {
    if (!locationOfGoods) return 'OPTIONAL'
    const qualifier = removePrefix(locationOfGoods.qualifierOfIdentification, 'QUALIFIER_OF_IDENTIFICATION_')

    switch (qualifier) {
      case 'Z': return 'REQUIRED'
      case 'X':
      case 'Y':
      case 'W':
      case 'V':
      case 'U':
      case 'T':
        return 'NOT_ALLOWED'
      default:
        return 'NOT_ALLOWED'
    }
  },
} as const

export default C0394Validator
